import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M10.5,22.3c0.3,0,1-0.5,1.3-0.8c4.2-4.4,8.5-8.9,12.7-13.3c0.6-0.7,0.6-1.3-0.1-2c-0.8-0.8-1.6-1.6-2.4-2.4 c-1.1-1.1-1.7-1.1-2.8,0.1c-2.3,2.7-4.7,5.4-7,8.1c-1.3,1.5-2.1,1.5-3.5,0.1c-1.2-1.2-2.4-2.4-3.6-3.6c-1.1-1-1.5-1-2.6,0 C2,9.1,1.4,9.7,0.8,10.3c-1.1,1.1-1.1,1.7,0,2.8c2.8,2.8,5.5,5.6,8.3,8.3C9.5,21.8,10.2,22.3,10.5,22.3z" />
    </g>
  </svg>
);
